var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{staticClass:"step-indicator"},_vm._l((_vm.steps),function(step){return _c("step-navigation-step",{key:step.id,tag:"li",attrs:{"step":step,"currentStep":_vm.currentStep}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }